import Vue from 'vue'
import Router from 'vue-router'

import Route from '@/components/Route'
// import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import Landing from '@/components/Landing'
import Register from '@/components/Register'

import PreOrder from '@/components/PreOrder'
import Log from '@/components/Log'

import Admin from '@/components/Admin'
import User from '@/components/User'
import LineOA from '@/components/LineOA'
// const Admin = () => import('@/components/Admin')
// const User = () => import('@/components/User')
// const LineOA = () => import('@/components/LineOA')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Landing
      // component: Login
    },
    {
      path: '/ld',
      component: Landing
    },
    {
      path: '/Log/TopUp',
      name: 'LogTopUp',
      component: Log.TopUp
    },

    // Log In & Register user
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/Route',
      name: 'Route',
      component: Route
    },

    // LINE OA
    {
      path: '/oa/login',
      name: 'LineLogin',
      component: LineOA.LineLogin
    },
    {
      path: '/oa/profile',
      name: 'LineProfile',
      component: LineOA.LineProfile
    },
    {
      path: '/oa/register',
      name: 'LineRegister',
      component: LineOA.LineRegister
    },
    {
      path: '/oa/inThailand',
      name: 'LineInThailand',
      component: LineOA.LineInThailand
    },

    // PRE-ORDER
    {
      path: '/pod/OrderList',
      name: 'OrderList',
      component: PreOrder.OrderList
    },
    {
      path: '/pod/OrderCreate',
      name: 'OrderCreate',
      component: PreOrder.OrderCreate
    },
    {
      path: '/pod/OrderUpdate',
      name: 'OrderUpdate',
      component: PreOrder.OrderUpdate
    },
    {
      path: '/pod/OrderTransport',
      name: 'OrderTransport',
      component: PreOrder.OrderTransport
    },

    // ADMIN MENU
    {
      path: '/Admin/Accounts',
      name: 'Accounts',
      component: Admin.Accounts
    },
    {
      path: '/Admin/Announce',
      name: 'Announce',
      component: Admin.Announce
    },
    {
      path: '/Admin/InvoiceList',
      name: 'InvoiceList',
      component: Admin.Invoice
    },
    {
      path: '/Admin/Refill',
      name: 'RefillList',
      component: Admin.Refill
    },
    {
      path: '/Admin/Transport',
      name: 'Transport',
      component: Admin.Transport
    },


    {
      path: '/User/Dashboard',
      name: 'Dashboard',
      component: User.Dashboard
    },
    {
      path: '/User/Profile',
      name: 'Profile',
      component: User.Profile
    },
    {
      path: '/User/Profile/:memCode',
      name: 'ProfileUser',
      component: User.Profile
    },
    {
      path: '/User/RegisterTracking',
      name: 'RegisterTracking',
      component: User.RegisterTracking
    },
    {
      path: '/User/UpdateTracking',
      name: 'UpdateTracking',
      component: User.UpdateTracking
    },
    {
      path: '/User/Tracking',
      name: 'Tracking',
      component: User.Tracking
    },
    {
      path: '/User/Export',
      name: 'Export',
      component: User.Export
    },
    {
      path: '/User/Delivery',
      name: 'Delivery',
      component: User.Delivery
    },
    {
      path: '/User/History',
      name: 'History',
      component: User.History
    },
    {
      path: '/User/Payment',
      name: 'Payment',
      component: User.Payment
    },
    {
      path: '/User/TopUp',
      name: 'TopUp',
      component: User.TopUp
    },
    {
      path: '/User/Revenue',
      name: 'Revenue',
      component: User.Revenue
    },
    {
      path: '/User/HistoryTopUp',
      name: 'HistoryTopUp',
      component: User.HistoryTopUp
    },
    {
      path: '/User/UpdateHistory',
      name: 'UpdateHistory',
      component: User.UpdateHistory
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js